<template>
  <div
    class="checkbox-input-pdp"
    :class="[
      { [$class('loading')]: loading },
    ]"
  >

  <label class="emoji-checkbox">
    <input
      :id="id"
      class="checkbox-input__input visually-hidden"
      :class="{ [$class('disabled')]: disabled }"
      :checked="checked"
      :disabled="disabled"
      :name="name"
      type="checkbox"
      :value="value"
      @input="updateVModel(value)"
      @click =toogle(id)
    >
      <span class='emoji' ><img :class="id" :src="addCart" alt="cart"></span>
    </label>
  </div>
</template>

<script>

/**
 * Vue: Checkbox input (checkbox-input)
 * -----------------------------------------------------------------------------
 * Checkbox input utility component.
 *
 * @param {Boolean} [checked] - Is checked?
 * @param {Boolean} [disabled] - Input is disabled.
 * @param {String} id - ID for input.
 * @param {String} label - Input label.
 * @param {Boolean} [loading] - Loading state.
 * @param {Number|String} [modelValue] - Current value provided by v-model.
 *
 * @emits update:model-value - Emit v-model update event.
 *
 */
export default {
  name: 'CheckboxInputPdp',

  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    labelClass: {
      type: String,
      default: 'text-body-m-regular',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [Number, String],
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Array],
      default: '',
      required: true,
    },
  },

  emits: {
    'update:model-value': () => true,
  },

  data() {
    return {
      localModelValue: '',
      addCart : cnvs.urls.assets.replace('placeholder', `addcart.png`),
      removeCart: cnvs.urls.assets.replace('placeholder', `removecart.png`),
    }
  },

  watch: {

    /**
     * Watch v-model value to update local value.
     */
    modelValue() {
      this.localModelValue = this.modelValue
    },
  },

  mounted() {
    this.localModelValue = this.modelValue
  },

  methods: {

    /**
     * Emit update v-model event.
     * @param {Number|String} value - Update value.
     */
    updateVModel(value) {
      this.$emit('update:model-value', value)
    },
    toogle(id){
      if(this.id == id){
        let checkbox = document.getElementById(this.id)
        let emoji =document.getElementsByClassName(this.id)[0]
        if (checkbox.checked) {
              emoji.src = this.removeCart; // Change to minus
          } else {
              emoji.src = this.addCart; // Change to plus
          }
      }
    }
  },
}
</script>

<style lang="scss">
@import './checkbox-input-pdp';
</style>
